export default __webpack_public_path__ + "static/media/overseas_en.6f0dd81b.csv";